import {useState} from 'react';

import styles from './styles/dropdown.module.css';

import {ReactComponent as ArrowDown} from '../../../assets/dashboard/arrow-down.svg';
import {ReactComponent as ArrowUp} from '../../../assets/dashboard/arrow-up.svg';

export default function Dropdown({ handleChange }) {
    const [selectedDateRange, setSelectedDateRange] = useState('오늘');
    const [openDropdown, setOpenDropdown] = useState(false);

    const selectDateRange = (dateRange) => {
        handleChange({ target: { name: 'date_range', value: dateRange.value } });
        setSelectedDateRange(dateRange.name);
        setOpenDropdown(false);
    };

    const dateRangeMap = [
        { name: '오늘', value: 'today' },
        { name: '이번 달', value: 'currentMonth' },
        { name: '올해', value: 'currentYear' },
        { name: '전체', value: 'accumulated' }
    ];

    return (
        <div className={styles.wrapper}>
            <button onClick={() => setOpenDropdown(!openDropdown)}>
                <p>{selectedDateRange}</p>
                {openDropdown ? <ArrowUp /> : <ArrowDown />}
            </button>
            {openDropdown &&
                <ul>
                    {dateRangeMap.map((dateRange, index) => (
                        <li key={index}
                            onClick={() => selectDateRange(dateRange)}
                        >
                            {dateRange.name}
                        </li>
                    ))}
                </ul>
            }
        </div>
    );
}
